import React, { useEffect, useMemo } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useChargebackModel } from "../chargebackModel";
import { IChargebackDetail } from "../chargebackType";
import { momentFormat, repairFormatNum } from "@/utils/utils";
import { useDictModel } from "@/views/base/dict/dictModel";
import YhTag from "@/components/YhTag";
import useNavModel from "@/model/navModel";
import { tableSize } from "@/utils/constants";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";

type statusType = {
    "maintenance.return.change": string //已作废
    "maintenance.return.io": string //已入库
    "maintenance.return.settle": string //已结算
    "maintenance.return.create": string //已开单
    "maintenance.return.pend": string //退单待审
    "maintenance.return.approve": string //退单已审
    [key: string]: any
}
const statusColor: statusType = {
    "maintenance.return.change": "red", //已作废
    "maintenance.return.io": "magenta", //已入库
    "maintenance.return.settle": "gold", //已结算
    "maintenance.return.create": "blue", //已开单
    "maintenance.return.pend": "geekblue", //退单待审
    "maintenance.return.approve": "lime", //退单已审
}

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, descRows, loading, rowsDescTotal, descTotal,
        loadData, setSelectedRowKeys, setDescRows
    } = useChargebackModel();
    const { getTreeNodeName } = useDictModel();
    const { selectedNavId, replaceNav } = useNavModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    useEffect(() => {
        loadData()
    }, [])

    const onLook = (code: string) => {
        let supplierEditKey = "4-4-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: code, mode: "look", parentInfo: { selectedNavId } },
            true
        );
    }

    const defaultColumns: ColumnsType<IChargebackDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t, r, i) => i + 1
        }, {
            title: '退单单号',
            width: 180,
            dataIndex: 'returnCode',
            render: (text: any) => <YhTootip text={text} onClick={() => onLook(text)} />,
        }, {
            title: '工单单号',
            width: 180,
            dataIndex: 'maintenanceCode',
            render: (text: any) => <YhTootip text={text} style={{ maxWidth: 180 }} />,
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '支付状态',
            width: 80,
            dataIndex: 'payStatus',
            render: (text) => getTreeNodeName(text)
        }, {
            title: '客户名称',
            width: 200,
            dataIndex: 'customerName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: 'VIN码',
            width: 200,
            dataIndex: 'vin',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '车牌号',
            width: 100,
            dataIndex: 'licensePlate',
            render: (text: any) => <YhTootip text={text} style={{ maxWidth: 100 }} />,
        }, {
            title: '送修人',
            width: 120,
            dataIndex: 'contact',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '送车电话',
            width: 95,
            dataIndex: 'phone',
        }, {
            title: '车辆类型',
            width: 150,
            dataIndex: 'vehicleTypeName',
            render: (text: any) => <YhTootip text={text} style={{ width: '150px' }} />,
        }, {
            title: '车辆型号',
            width: 80,
            dataIndex: 'vehicleModel',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '维修类型',
            width: 80,
            dataIndex: 'serviceNatureName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '配件数',
            width: 80,
            dataIndex: 'materialNum',
        }, {
            title: '工时数',
            width: 80,
            dataIndex: 'workHour',
        }, {
            title: '工时费',
            width: 80,
            dataIndex: 'workingHoursAmount',
            render: (text) => `￥${repairFormatNum(text)}`
        }, {
            title: '配件费',
            width: 80,
            dataIndex: 'materialScienceAmount',
            render: (text) => `￥${repairFormatNum(text)}`
        }, {
            title: '费用合计',
            width: 80,
            dataIndex: 'totalAmount',
            render: (text) => `￥${repairFormatNum(text)}`

        }, {
            title: '优惠金额',
            width: 80,
            dataIndex: 'discountTotalAmount',
            render: (text) => `￥${repairFormatNum(text)}`
        }, {
            title: '优惠后工时费',
            width: 110,
            dataIndex: 'workHourAmount',
            render: (text) => `￥${repairFormatNum(text)}`
        }, {
            title: '优惠后配件费',
            width: 110,
            dataIndex: 'materialHourAmount',
            render: (text) => `￥${repairFormatNum(text)}`
        }, {
            // title: '应收金额',
            title: '营业额',
            width: 80,
            dataIndex: 'receivableTotalAmount',
            render: (text) => `￥${repairFormatNum(text)}`
        }, {
            title: '已收金额',
            width: 80,
            dataIndex: 'receivableAmount',
            render: (text) => `￥${repairFormatNum(text)}`
        }, {
            title: '销售毛利',
            width: 80,
            dataIndex: 'grossProfit',
            render: (text) => `￥${repairFormatNum(text)}`
        }, {
            title: '销售成本',
            width: 80,
            dataIndex: 'totalCost',
            render: (text) => `￥${repairFormatNum(text)}`
        }, {
            title: '结算类型',
            width: 100,
            dataIndex: 'payType',
            // render: (text) => getTreeNodeName(text)，
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{getTreeNodeName(text)}</p></Tooltip>,
        }, {
            title: '结算方式',
            width: 80,
            dataIndex: 'paymentMethodName',
            // render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{getTreeNodeName(text) ? getTreeNodeName(text) : text}</p></Tooltip>,
            render: (text: any, record: any) => <Tooltip placement="topLeft" title={record?.settleDetails?.[0]?.payMethodName ?? record?.settleDetails?.[0]?.accountName}><p className="ellipsis">{record?.settleDetails?.[0]?.payMethodName ?? record?.settleDetails?.[0]?.accountName}</p></Tooltip>,


        }, {
            title: '结算方',
            width: 80,
            dataIndex: 'settlementPartyName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '发票类型',
            width: 160,
            dataIndex: 'invoiceTypeName',
        }, {
            title: '开票状态',
            width: 80,
            dataIndex: 'invoiceStatus',
            render: (text) => text === "1" ? "已开票" : "未开票"
        }, {
            title: '服务地点',
            width: 80,
            dataIndex: 'serviceLocationName',
        }, {
            title: '进厂时间',
            width: 130,
            dataIndex: 'enterTime',
            render: (text) => momentFormat(text)
        }, {
            title: '出厂时间',
            width: 130,
            dataIndex: 'deliveryTime',
            render: (text) => momentFormat(text)
        }, {
            title: '制单员',
            width: 70,
            dataIndex: 'createUser',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '制单时间',
            width: 130,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: '结算员',
            width: 70,
            dataIndex: 'reckoner',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '结算时间',
            width: 130,
            dataIndex: 'settleTime',
            render: (text) => momentFormat(text)
        }, {
            title: '预约单号',
            width: 180,
            dataIndex: 'appointmentCode',
        }, {
            title: '作废原因',
            width: 160,
            dataIndex: 'cancelReason',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '退单原因',
            width: 160,
            dataIndex: 'returnReason',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '财务备注',
            width: 160,
            dataIndex: 'fmsNote',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '退单状态',
            width: 80,
            dataIndex: 'status',
            render: (text) => <YhTag color={statusColor[text]} text={getTreeNodeName(text)} />,
        }, {
            title: '打印次数',
            width: 80,
            align: "center",
            dataIndex: 'printingTimes',
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        },
    ];

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "orderReturn", "roleCodes": roles };
        return getRoleColumns("orderReturn", "主单", defaultColumns, params);
    }, [roles, dataSource]);

    //点击行选高亮
    const onRow = (record: IChargebackDetail) => {
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };
    const onRightClick = (record: IChargebackDetail) => {
        setDescRows([record])
        setSelectedRowKeys([record.id as string])
    }
    // const countX = (arr: any) => {
    //     return arr.reduce((cur: any, next: any) => {
    //         return cur + (next.width ? next.width : 0)
    //     })
    // }
    return (
        <Table
            bordered
            loading={loading}
            style={{ cursor: "pointer" }}
            size={tableSize}
            rowKey={record => record.id as string}
            rowSelection={{
                onChange: (selectedRowKeys: React.Key[], selectedRows: IChargebackDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setDescRows(selectedRows)
                },
                selectedRowKeys
            }}
            columns={roleColumns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showSizeChanger: true,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault();
                    onRightClick(record)

                }
            })}
            scroll={{ x: "max-content", y: 'calc(100vh - 370px)' }}
        // summary={() => (
        //     <Table.Summary fixed>
        //         <Table.Summary.Row className="table-total-box">
        //             <Table.Summary.Cell index={0}>
        //                 <div className="title">合计</div>
        //             </Table.Summary.Cell>
        //             <Table.Summary.Cell index={1} />
        //             <Table.Summary.Cell index={2} />
        //             <Table.Summary.Cell index={3} />
        //             <Table.Summary.Cell index={4} />
        //             <Table.Summary.Cell index={5} />
        //             <Table.Summary.Cell index={6} />
        //             <Table.Summary.Cell index={7} />
        //             <Table.Summary.Cell index={8} />
        //             <Table.Summary.Cell index={9} />
        //             <Table.Summary.Cell index={10} />
        //             <Table.Summary.Cell index={11} />
        //             <Table.Summary.Cell index={12} />
        //             <Table.Summary.Cell index={13} />
        //             <Table.Summary.Cell index={14}>
        //                 <span className="red">{selectedRowKeys.length === 0 ? descTotal.materialNum : repairFormatNum(rowsDescTotal.materialNum)}</span>
        //             </Table.Summary.Cell>
        //             <Table.Summary.Cell index={15}>
        //                 <span className="red">{selectedRowKeys.length === 0 ? descTotal.workHour : repairFormatNum(rowsDescTotal.workHour)}</span>
        //             </Table.Summary.Cell>
        //             <Table.Summary.Cell index={16} />
        //             <Table.Summary.Cell index={17} />
        //             <Table.Summary.Cell index={18} />
        //             {/* >
        //                 <span className="red">{selectedRowKeys.length === 0 ? descTotal.totalAmount : repairFormatNum(rowsDescTotal.totalAmount)}</span>
        //             </Table.Summary.Cell> */}
        //             <Table.Summary.Cell index={19} />
        //             {/* >
        //                 <span className="red">{selectedRowKeys.length === 0 ? descTotal.discountTotalAmount : repairFormatNum(rowsDescTotal.discountTotalAmount)}</span>
        //             </Table.Summary.Cell> */}
        //             <Table.Summary.Cell index={20} />
        //             <Table.Summary.Cell index={21} />
        //             <Table.Summary.Cell index={22} />
        //             {/* >
        //                 <span className="red">{selectedRowKeys.length === 0 ? descTotal.receivableTotalAmount : repairFormatNum(rowsDescTotal.receivableTotalAmount)}</span>
        //             </Table.Summary.Cell> */}
        //             <Table.Summary.Cell index={23} />
        //             {/* >
        //                 <span className="red">{selectedRowKeys.length === 0 ? descTotal.receivableAmount : repairFormatNum(rowsDescTotal.receivableAmount)}</span>
        //             </Table.Summary.Cell> */}
        //             <Table.Summary.Cell index={24} />
        //             <Table.Summary.Cell index={25} />
        //             <Table.Summary.Cell index={26} />
        //             <Table.Summary.Cell index={27} />
        //             <Table.Summary.Cell index={28} />
        //             <Table.Summary.Cell index={29} />
        //             <Table.Summary.Cell index={30} />
        //             <Table.Summary.Cell index={31} />
        //             <Table.Summary.Cell index={32} />
        //             <Table.Summary.Cell index={33} />
        //             <Table.Summary.Cell index={34} />
        //             <Table.Summary.Cell index={35} />
        //             <Table.Summary.Cell index={36} />
        //             <Table.Summary.Cell index={37} />
        //             <Table.Summary.Cell index={38} />
        //             <Table.Summary.Cell index={39} />
        //             <Table.Summary.Cell index={40} />
        //             <Table.Summary.Cell index={41} />
        //             <Table.Summary.Cell index={42} />
        //             <Table.Summary.Cell index={43} />
        //             <Table.Summary.Cell index={44} />
        //         </Table.Summary.Row>
        //     </Table.Summary>
        // )}
        />
    )
}
